import React from 'react';
import React3 from 'react-three-renderer';
import * as THREE from 'three';

class GCBox extends React.Component {
  render() {
    return (
      <object3D frustumCulled position={this.props.position}>
        <mesh receiveShadow={!this.props.noShadow}>
          <boxGeometry {...this.props.size} />
          <meshStandardMaterial
            color={0xffffff}
            side={THREE.DoubleSide}
            metalness={0.3}
            roughness={0.2}
            opacity={0.4}
            transparent={this.props.transparent}
          />
        </mesh>
      </object3D>
    );
  }
}

export default class Room extends React.Component {
  thickness = 2;
  get roomHeight() {
    return 2;
  }
  render() {
    const { roomHeight, thickness } = this;
    const {
      configuration,

      configuration: {
        types,
        types: { top, bottom, fields },
        dim,
        dim: { width, length: depth, walkway }
      }
    } = this.props;
    const floorPosition = new THREE.Vector3(0, thickness / 2, 0);
    const floorSize = {
      width,
      depth,
      height: thickness
    };
    const wallAPosition = new THREE.Vector3(
      width / 2 + thickness / 2,
      roomHeight / 2 - thickness / 2,
      0
    );
    const wallASize = { width: thickness, depth, height: roomHeight };
    const wallAOPosition = new THREE.Vector3(
      -(width / 2 + thickness / 2),
      roomHeight / 2 - thickness / 2,
      0
    );

    const wallBPosition = new THREE.Vector3(
      0,
      roomHeight / 2 - thickness / 2,
      depth / 2 + thickness / 2
    );
    const wallBSize = {
      width: width + thickness * 2,
      depth: thickness,
      height: roomHeight
    };
    const wallBOPosition = new THREE.Vector3(
      0,
      roomHeight / 2 - thickness / 2,
      -(depth / 2 + thickness / 2)
    );

    const door = 36;
    const doorHeight = 84;
    const doorSize = { width: door, depth: thickness, height: doorHeight };
    const doorPosition = new THREE.Vector3(
      -width / 2 - door / 2,
      doorHeight / 2,
      -depth / 2 + top.dim.depth + walkway / 2 + door / 2
    );

    return (
      <object3D name='global-object'>
        {/* <resources>
          <texture
            url='./assets/img/textures/concrete.jpg'
            wrapS={THREE.RepeatWrapping}
            wrapT={THREE.RepeatWrapping}
            anisotropy={16}
            resourceId='clothTexture'
          />
        </resources> */}
        <GCBox size={floorSize} position={floorPosition} floor />
        <GCBox size={wallASize} position={wallAPosition} transparent noShadow />
        <GCBox
          size={wallASize}
          position={wallAOPosition}
          transparent
          noShadow
        />
        <GCBox size={wallBSize} position={wallBPosition} transparent noShadow />
        <GCBox
          size={wallBSize}
          position={wallBOPosition}
          transparent
          noShadow
        />
        {/* <GCBox size={doorSize} position={doorPosition} transparent noShadow /> */}
      </object3D>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Results/ResultsScene/Room/index.js